export default __webpack_public_path__ + "locales/pt/Common.json?hash=3676f80651f2e60622f4da7738a25146";